// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"8c074e6f","767":"a0a7c320"}[chunkId] + ".chunk.js";
};